export default __webpack_public_path__ + "static/media/Linkedin-02.7c37f10c.svg";